import { useEffect, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useAppDispatch } from '@shared/store';

import { SuperAdminAuthenticatedPath } from '@shared/constants/routes.constants';
import { useSignInControllerSignInAdminMutation } from '@shared/services/apiService/apiService';
import { actions } from '@shared/store/ducks';
import { SignInFormValues as SignSuperAdminInFormValues } from '@pages/SuperAdminSignIn/types';
import { getSignInErrorMessage } from '@shared/utils/apiError.utils';

export const useSuperAdminSignIn = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [errorMsg, setErrorMsg] = useState('');
  const [signInSuperAdmin] = useSignInControllerSignInAdminMutation();
  const { handleSubmit, setValue, control, ...formMethods } = useForm<SignSuperAdminInFormValues>({
    mode: 'onTouched',
    defaultValues: {
      login: '',
      password: '',
    },
  });

  const login = useWatch({ control, name: 'login' });
  const password = useWatch({ control, name: 'password' });

  useEffect(() => {
    setErrorMsg('');
  }, [login, password]);

  const onSubmit = handleSubmit(async (data) => {
    setErrorMsg('');

    const res: any = await signInSuperAdmin({
      signInRequestDto: {
        login: data.login,
        password: data.password,
      },
    });

    if (res.error) {
      setErrorMsg(t(getSignInErrorMessage(res.error)));
    } else {
      setErrorMsg('');
      toast.dismiss();
      dispatch(actions.auth.signInSuperAdmin({ accessToken: res.data.accessToken }));
      navigate(SuperAdminAuthenticatedPath.COMPANIES);
    }
  });

  return {
    control,
    setValue,
    onSubmit,
    errorMsg,
    ...formMethods,
  };
};
